const accountManagementActionTypes = {
  FETCH_REQUEST_OTP_INFO: 'FETCH_REQUEST_OTP_INFO',
  FETCH_REQUEST_OTP_INFO_SUCCESS: 'FETCH_REQUEST_OTP_INFO_SUCCESS',
  FETCH_REQUEST_OTP_INFO_FAIL: 'FETCH_REQUEST_OTP_INFO_FAIL',

  FETCH_SIGN_WITH_OTP_INFO: 'FETCH_SIGN_WITH_OTP_INFO',
  FETCH_SIGN_WITH_OTP_INFO_SUCCESS: 'FETCH_SIGN_WITH_OTP_INFO_SUCCESS',
  FETCH_SIGN_WITH_OTP_INFO_FAIL: 'FETCH_SIGN_WITH_OTP_INFO_FAIL',

  FETCH_LOGIN_INFO: 'FETCH_LOGIN_INFO',
  FETCH_LOGIN_INFO_SUCCESS: 'FETCH_LOGIN_INFO_SUCCESS',
  FETCH_LOGIN_INFO_FAIL: 'FETCH_LOGIN_INFO_FAIL',
};

export default accountManagementActionTypes;
